(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-mobile-conversion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-mobile-buy-bar]').forEach((bar) => {
      const sectionId = bar.dataset.sectionId;
      const productPage = document.getElementById(`product-${sectionId}`);
      if (!productPage) return;

      const variants = productPage.querySelector('product-variants');
      const primaryButton = productPage.querySelector('[data-js-product-add-to-cart]');
      const primaryPrice = productPage.querySelector('[data-js-product-price-compact] [data-js-product-price-original]');
      const stickyButton = bar.querySelector('[data-mobile-product-submit]');
      const stickyPrice = bar.querySelector('[data-mobile-product-price]');
      const stickyVariant = bar.querySelector('[data-mobile-product-variant]');
      const promotionPrice = productPage.querySelector('[data-product-promotion-price]');
      const promotionOriginal = productPage.querySelector('[data-product-promotion-original]');
      const priceDataElement = bar.querySelector('[data-mobile-product-prices]');
      const promotionalPrices = priceDataElement ? JSON.parse(priceDataElement.textContent) : null;

      const update = () => {
        const selectedVariantId = productPage.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
        const promotionalPrice = promotionalPrices?.[selectedVariantId];
        if (stickyPrice) stickyPrice.textContent = promotionalPrice?.final || primaryPrice?.textContent.trim() || '';
        if (promotionPrice && promotionalPrice) promotionPrice.textContent = promotionalPrice.final;
        if (promotionOriginal && promotionalPrice) promotionOriginal.textContent = promotionalPrice.original;
        if (stickyVariant) {
          const selected = Array.from(productPage.querySelectorAll('.product-variant__input:checked')).map((input) => input.value);
          stickyVariant.textContent = selected.join(' · ');
        }
        if (primaryButton && stickyButton) {
          stickyButton.disabled = primaryButton.classList.contains('disabled') || primaryButton.disabled;
          stickyButton.textContent = primaryButton.querySelector('[data-js-product-add-to-cart-text]')?.textContent.trim() || primaryButton.textContent.trim();
        }
      };

      variants?.addEventListener('VARIANT_CHANGE', update);
      variants?.addEventListener('change', () => requestAnimationFrame(update));
      stickyButton?.addEventListener('click', () => {
        if (!stickyButton.disabled) primaryButton?.click();
      });
      update();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
